// extracted by mini-css-extract-plugin
module.exports = {"companyItem__link":"CompanyItem_companyItem__link__PG0qF","companyItem__description":"CompanyItem_companyItem__description__BvnMQ"};